
export const sFechaPublicacion = '2026-10-18T21:45:19.9384238-06:00';
export const sVersion = 'vf1.1.610182145';
            